module.exports = __webpack_public_path__ + "img/4444.5c93932f.png";